import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const checkboxGroupFn = /* @__PURE__ */ createRecipe('CheckboxGroup', {
  "size": "md"
}, [])

const checkboxGroupVariantMap = {
  "isInline": [
    "true"
  ],
  "size": [
    "sm",
    "md",
    "lg"
  ]
}

const checkboxGroupVariantKeys = Object.keys(checkboxGroupVariantMap)

export const checkboxGroup = /* @__PURE__ */ Object.assign(memo(checkboxGroupFn.recipeFn), {
  __recipe__: true,
  __name__: 'checkboxGroup',
  __getCompoundVariantCss__: checkboxGroupFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: checkboxGroupVariantKeys,
  variantMap: checkboxGroupVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, checkboxGroupVariantKeys)
  },
  getVariantProps: checkboxGroupFn.getVariantProps,
})